import axios from "axios";
import {
  getItem,
  removeAll,
  setItem,
} from "../../utilities/authUtils";
import { APIPATH } from "../../constants/Constant";

const apiInstance = axios.create({
  baseURL: APIPATH,
  crossDomain: false,
});

apiInstance.interceptors.request.use(
  (config) => {
    const token = getItem("header_token");

    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      removeAll();
      setItem("isSessionExpired", true);
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default apiInstance;